import { z } from 'zod';

const sidebarOptions = [
  'case',
  'profile',
  'help',
  'settings',
  'chat',
  'notify',
  'member-profile',
  'recipient-upload',
  'unos',
];

export const searchParamsSchema = z.object({
  sidebar: z.enum(sidebarOptions).optional(),
  'sidebar-closed': z.enum(sidebarOptions).optional(),
  'sidebar-return': z.enum(sidebarOptions).optional(),
  'sidebar-expanded': z.boolean().optional(),
  'field-id': z.number().nonnegative().optional(),
  'case-id': z.number().nonnegative().optional(),
  'task-id': z.number().nonnegative().optional(),
  'case-tab': z.enum(['tasks', 'people']).optional(),
  // Case list filter params (used for shareable/bookmarkable filter URLs)
  'case-status': z.enum(['Open', 'Closed', 'All']).optional(),
  'case-risk': z.enum(['True', 'False', 'All']).optional(),
  'case-stage': z.array(z.string()).optional(),
  'case-tags': z.array(z.number()).optional(),
  'case-workflows': z.array(z.string()).optional(),
  'case-tag-mode': z.enum(['OR', 'AND']).optional(),
  'case-search': z.string().optional(),
  'case-page': z.number().nonnegative().optional(),
  'case-rows': z.number().positive().optional(),
  'case-sort-by': z
    .enum(['DEFAULT', 'NAME', 'WORKFLOW', 'CREATE_DATE', 'LAST_ACTIVITY', 'NEXT_DUE_DATE', 'PROGRESS', 'NOTES', 'RANK'])
    .optional(),
  'case-sort-dir': z.enum(['asc', 'desc']).optional(),
});

export type SearchParams = z.infer<typeof searchParamsSchema>;

export const registrationSearchParams = z.object({
  factor: z.string().optional(),
});

export const caseRouteSchema = z.object({
  caseId: z.coerce.number().int().nonnegative(),
});

export const caseSearchSchema = z.object({
  sidebar: z.string().optional(),
});

export const taskRouteSchema = z.object({
  caseId: z.coerce.number().int().nonnegative(),
  taskId: z.coerce.number().int().nonnegative(),
});

export const chatRouteSchema = z.object({
  chatId: z.coerce.number().int().nonnegative(),
});

export const resetPasswordSearchSchema = z.object({
  token: z.string().optional(),
});

export const teamRouteSchema = z.object({
  teamId: z.coerce.number().int().nonnegative(),
});
